(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("AutoPay Banner Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope, $state, UserSession) {
    // console.log("AutoPay Banner Controller Func: ", $scope);
    $scope.wcmContent = wcmContent;
    $scope.continue = function() {
      if(cvsUtility.componentName() && ((cvsUtility.componentName()=="RFR")|| cvsUtility.componentName()== "myAccount")){
        window.top.location = createChannelUrl('recurringPayment');
      }else{
        $state.go("payment-methods", {'paymenttype': 'auto'});
      }

    };
  }

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/autopayBanner/autopayBanner.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "$state", "userSession"];
  angular.module('cvsApp').directive('autopayBanner', directiveFunction);


})();
